import React from 'react';

import { SimpleCallback } from '../../../typings';
import { Button } from '../../button/button';

import './showcase-lesson-teaser-card__button.scss';

interface Props {
    onClick?: SimpleCallback;
    text?: string;
}

export const ShowcaseLessonTeaserCardButton = ({ onClick, text }: Props) => {
    if (!text || !onClick) {
        return null;
    }

    return (
        <Button
            className="showcase-lesson-teaser-card__button"
            onClick={onClick}
            transparencyTheme={Button.TRANSPARENCY_THEME.DARK}
            view={Button.VIEW.SECONDARY}
        >
            {text}
        </Button>
    );
};
